import { HttpParams } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserService, SportService } from '@app/core';
import { CommonService } from '@app/core/services/common.service';
import { ReplaySubject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-upcoming-picks',
  templateUrl: './upcoming-picks.component.html',
  styleUrls: ['./upcoming-picks.component.scss'],
})
export class UpcomingPicksComponent implements OnInit {
  protected destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);
  upcomingPicks: any;
  @Input() userId: any = null;
  authuserId = 0;
  selectedSport = '';
  user = '';
  constructor(
    private _user: UserService,
    private _sport: SportService,
    private _activated: ActivatedRoute,
    private _common: CommonService
  ) { }

  ngOnInit(): void {
    this._activated.parent?.data.pipe(takeUntil(this.destroyed$)).subscribe(async (data) => {
      let sport = data['sport'] || '';
      this.userId = data['userId'];
      let params = new HttpParams()
        .set('user_id', this.userId)
        .set('sports', sport);
      let res = await this._user.upcomingPicks(params);
      this.upcomingPicks = res.data;
      this.selectedSport = sport;
      this.user = res.user;
      this.authuserId = this._common.JwTUserId;
    });
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
